import { useAuth } from '../contexts/AuthContext';
import { useImpersonation } from '../contexts/ImpersonationContext';

export const useImpersonatedAuth = () => {
  const auth = useAuth();
  const { isImpersonating, impersonatedUser, originalUser } = useImpersonation();

  // When impersonating, the AuthContext user is already the impersonated user —
  // /auth/me runs against the impersonation JWT (decoded.userId = target user) and
  // returns the full user with userCompanies/permissions. We deliberately do NOT
  // overwrite it with `impersonatedUser` here: the ImpersonationContext copy is
  // persisted in slim form to avoid a localStorage QuotaExceededError, so after a
  // page reload it would lack the fields permission-gating hooks rely on.
  if (isImpersonating && impersonatedUser) {
    return {
      ...auth,
      originalUser: originalUser,
      isImpersonating: true
    };
  }

  // When not impersonating, return the normal auth context
  return {
    ...auth,
    originalUser: null,
    isImpersonating: false
  };
};
